import { breakpoint, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  overlayContainer: css({
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    background: 'linear-gradient(360deg, #EEF3F6 65%, rgba(238, 243, 246, 0) 100%)',
    height: 480,
    bottom: 6,

    [mediaQueryHelper(breakpoint.phone)]: {
      background: 'linear-gradient(360deg, #EEF3F6 75%, rgba(238, 243, 246, 0) 100%)',
      height: 250,
      bottom: '-100px',
    },
  }),

  noOverlayContainer: css({
    margin: 'auto',
    paddingTop: spacing.large,
    paddingBottom: spacing.large,

    [mediaQueryHelper(breakpoint.phone)]: {
      paddingBottom: 80,
    },
  }),
}

export default styles
